module.exports = __webpack_public_path__ + "static/media/blueBalloon.a9b77291.svg";